"use strict";

import Modal from 'bootstrap/js/dist/modal';

export function init() {

    var mainFormId = hintAddressFormId();

    if (isModalAvailable() && mainFormId != null) {
        document.onreadystatechange = function () {
            let validateModal = document.getElementById('addressValidationModal');
            let validateModalInstance = Modal.getInstance(validateModal);
            let mainFormFieldPrefix = hintAddressFormFieldPrefix(mainFormId);
            setAddressTexts(mainFormFieldPrefix);
            prepareOnSubmitForm(mainFormId, mainFormFieldPrefix);
            prepareOnCloseForm(mainFormId);
            validateModalInstance.show();
        }
    }

    function setAddressTexts(mainFormFieldPrefix) {
        let dataSources = ["service", "user"];
        let targetElements = ["validate_serviceAddress", "validate_userAddress"]

        let i;
        for (i = 0; i < dataSources.length; i++) {
            let dataSource = dataSources[i];
            let targetElementId = targetElements[i];

            let targetElement = document.getElementById(targetElementId);

            let country = document.getElementById(mainFormFieldPrefix + 'Country');
            let selectedCountry = country.options[country.selectedIndex].innerHTML;
            let countryCode = targetElement.dataset.countryCode;

            targetElement.innerHTML = '';
            if (document.getElementById('validate_' + dataSource + '_shippingStreetNumber') != null) {
                if (document.getElementById('validate_streetNumberFirst').value === "1") {
                    targetElement.innerHTML += document.getElementById('validate_' + dataSource + '_shippingStreetNumber').value + ' ' + document.getElementById('validate_' + dataSource + '_shippingStreet').value;
                } else {
                    targetElement.innerHTML += document.getElementById('validate_' + dataSource + '_shippingStreet').value + ' ' + document.getElementById('validate_' + dataSource + '_shippingStreetNumber').value;
                }
            } else {
                targetElement.innerHTML += document.getElementById('validate_' + dataSource + '_shippingStreet').value;
            }
            targetElement.innerHTML += '<br />';
            if (document.getElementById('validate_' + dataSource + '_shippingAddressAddon').value !== '') {
                targetElement.innerHTML += document.getElementById('validate_' + dataSource + '_shippingAddressAddon').value;
                targetElement.innerHTML += '<br />';
            }
            targetElement.innerHTML += document.getElementById('validate_' + dataSource + '_shippingZip').value + ' ' + document.getElementById('validate_' + dataSource + '_shippingCity').value;
            if (document.getElementById('validate_' + dataSource + '_shippingStateName') != null && document.getElementById('validate_user_shippingStateName') != null) {
                targetElement.innerHTML += ', ' + document.getElementById('validate_' + dataSource + '_shippingStateName').value;
            }
            targetElement.innerHTML += '<br />';
            let countryOutput = countryCode ? '<span class="btn-icon"><img src="/static/img/flags/4x3/round/flag_' + countryCode + '.svg" width="18" class="me-sm-2 mb-1" />' + selectedCountry + '</span>' : selectedCountry;
            targetElement.innerHTML += countryOutput;

        }
    }

    function prepareOnSubmitForm(mainFormId, mainFormFieldPrefix) {
        let modalForm = document.getElementById('validate-form');
        let mainForm = document.getElementById(mainFormId);

        modalForm.addEventListener('submit', function (e) {
            let modalFormLoading = document.getElementById('addressValidationLoading');
            modalFormLoading.removeAttribute("hidden");

            e.preventDefault();
            if (e.target.elements.validate_selectSource.value === 'service') {
                document.getElementById(mainFormFieldPrefix + 'Street').value = e.target.elements.validate_service_shippingStreet.value;
                if (typeof e.target.elements.validate_service_shippingStreetNumber !== 'undefined' && document.getElementById(mainFormFieldPrefix + 'StreetNumber') != null) {
                    document.getElementById(mainFormFieldPrefix + 'StreetNumber').value = e.target.elements.validate_service_shippingStreetNumber.value;
                }
                document.getElementById(mainFormFieldPrefix + 'AddressAddon').value = e.target.elements.validate_service_shippingAddressAddon.value;
                document.getElementById(mainFormFieldPrefix + 'City').value = e.target.elements.validate_service_shippingCity.value;
                document.getElementById(mainFormFieldPrefix + 'Zip').value = e.target.elements.validate_service_shippingZip.value;
                if (typeof e.target.elements.validate_service_shippingState !== 'undefined' && document.getElementById(mainFormFieldPrefix + 'State') != null) {
                    document.getElementById(mainFormFieldPrefix + 'State').value = e.target.elements.validate_service_shippingState.value;
                }
            } else {
                document.getElementById(mainFormFieldPrefix + 'Street').value = e.target.elements.validate_user_shippingStreet.value;
                if (typeof e.target.elements.validate_user_shippingStreetNumber !== 'undefined' && document.getElementById(mainFormFieldPrefix + 'StreetNumber') != null) {
                    document.getElementById(mainFormFieldPrefix + 'StreetNumber').value = e.target.elements.validate_user_shippingStreetNumber.value;
                }
                document.getElementById(mainFormFieldPrefix + 'AddressAddon').value = e.target.elements.validate_user_shippingAddressAddon.value;
                document.getElementById(mainFormFieldPrefix + 'City').value = e.target.elements.validate_user_shippingCity.value;
                document.getElementById(mainFormFieldPrefix + 'Zip').value = e.target.elements.validate_user_shippingZip.value;
                if (typeof e.target.elements.validate_user_shippingState !== 'undefined' && document.getElementById(mainFormFieldPrefix + 'State') != null) {
                    document.getElementById(mainFormFieldPrefix + 'State').value = e.target.elements.validate_user_shippingState.value;
                }
            }
            mainForm.submit();
            return false;
        });
    }

    function prepareOnCloseForm(addressFormId) {
        let shippingAddressLookupName = hintShippingAddressLookupName(addressFormId);
        let validateModal = document.getElementById('addressValidationModal');
        validateModal.addEventListener('hide.bs.modal', function () {
            document.getElementById(shippingAddressLookupName).value = '';
        })
    }

    function hintAddressFormId() {
        if (document.getElementById('customer-form') != null) {
            return 'customer-form';
        } else if (document.getElementById('guest-form') != null) {
            return 'guest-form';
        } else {
            return '';
        }
    }

    function hintAddressFormFieldPrefix(addressFormId) {
        if (addressFormId === 'customer-form') {
            return 'customer_shipping';
        }
        if (addressFormId === 'guest-form') {
            let shippingAddressAlternative = document.getElementById('guest_shippingAddressAlternative');
            if (shippingAddressAlternative != null && shippingAddressAlternative.checked) {
                return 'guest_shipping';
            } else {
                return 'guest_customer';
            }
        }
        return null;
    }

    function hintShippingAddressLookupName(addressFormId) {
        if (addressFormId === 'customer-form') {
            return 'customer_shippingAddressLookup';
        }
        if (addressFormId === 'guest-form') {
            return 'guest_shippingAddressLookup';
        }
        return null;
    }

    function isModalAvailable() {
        if (document.getElementById('addressValidationModal') != null) {
            return true;
        } else {
            return false;
        }
    }

}